import { ProfileState } from "../types";

export const initialState: ProfileState = {
  loading: false,
  updating: false,
  error: null,
  profile: null,
  form: {
    fullName: "",
    mobileNumber: "",
  },
};
